export const UPLOADTYPE = {
  SKU_CODE: 'SKU_CODE',
  SKU_CATEGORY: 'SKU_CATEGORY',
  SPECIAL_TEMPLATE: 'SPECIAL_TEMPLATE',
  SETTLEMENT: 'SETTLEMENT',
  WAREHOUSE_TRANSPORT: 'WAREHOUSE_TRANSPORT',
  SETTLEMENT_SEA_TRANSPORT: 'SETTLEMENT_SEA_TRANSPORT',
  MULTISTAGE_SETTLEMENT: 'MULTISTAGE_SETTLEMENT',
  SETTLEMENT_PRICE: 'SETTLEMENT_PRICE',
  WAREHOUSE_ONLY: 'WAREHOUSE_ONLY',
}

export const FILEURL = {
  CUSTOMER_SKU_EXPORT: '/customer/sku/export',
  CUSTOMER_MULTI_INFO: 'customer_export/multi/info',
}

export const fileNameList = {
  'CP001': '专车明细',
  'CP002': '零担明细',
  'CP003': '区域配明细',
  'CP004': '点位配明细',
}

export const TEMPLATEURL = {
  IMPORT_ORDER: '/1004/cus_template/import_order_v12.xlsx',
  CUS_TEMPLATEIMPORT_ORDER: '/1004/cus_template/cus_templateimport_order_v11.xlsx',
  CUS_SPECIAL_IMPORT: '/1004/cus_template/cus_special_template_import_v3.xlsx',
  EXCEL_TEMPLATE: 'customer_export/excel_template',
  WAREHOUSEONLY: 'unify/order/v2/warehouseOnly/export',
  WAREHOUSEDISCHARGE: '/unify/order/v2/warehouse_transport/temp/export', // 一装多卸模板下载
  WAREHOUSETRANSPORT: '/unify/order/v2/warehouseTransport/export',
  WAREHOUSEDISCHARGEONLY: '/unify/order/v2/warehouse_only/temp/export',
  PLAN_ORDER: '/unify/order/v2/warehouse_transport/plan_order/export', // WMS 仓配计划单模板下载
}

export const TEMPLATETYPE = {
  SPECIAL: {
    type: 'SPECIAL',
    productName: '专用模板'
  },
  SKU_CATEGORY: {
    type: 'SKU_CATEGORY',
    productName: '货品品类'
  },
  SKU_CODE: {
    type: 'SKU_CODE',
    productName: '货品明细'
  },
  SETTLEMENT: {
    type: 'SETTLEMENT',
    productName: '结算订单专用导入'
  },
  SETTLEMENT_PRICE: {
    type: 'SETTLEMENT_PRICE',
    productName: '结算订单专用导入'
  },
  SETTLEMENT_SEA_TRANSPORT: {
    type: 'SETTLEMENT_SEA_TRANSPORT',
    productName: '海运订单导入'
  },
  MULTISTAGE_SETTLEMENT: {
    type: 'MULTISTAGE_SETTLEMENT',
    productName: '补录订单导入专用'
  }
}
// 仓配
export const WAREHOUSETYPE = {
  TRANSPORT: 'WAREHOUSE_TRANSPORT',
  WAREHOUSE: 'WAREHOUSE_ONLY',
  ORDER_RULE: 'ORDER_RULE',
  STORE: 'STORE', // 入库
  DELIVER: 'DELIVER', // 出库
  PLAN_FORMAL_ORDER: 'PLAN_FORMAL_ORDER', // WMS仓配一体出库导入下单
  STORE_V2: 'STORE_V2', // 仓配入库V2
  DELIVER_ONLY_V2: 'DELIVER_ONLY_V2', // 仓配出库V2
  DELIVER_TRANSPORT_V2: 'DELIVER_TRANSPORT_V2', // 仓配一体V2
  STORE_V2_BIZ: 'STORE_V2_BIZ', // 仓配入库V2业务版
  DELIVER_ONLY_V2_BIZ: 'DELIVER_ONLY_V2_BIZ', // 仓配出库V2业务版
  DELIVER_TRANSPORT_V2_BIZ: 'DELIVER_TRANSPORT_V2_BIZ', // 仓配一体V2业务版
}

// 导入总裁版到业务板给接口入参映射
export  const UsualToBusiness = {
  STORE_V2: 'STORE_V2_BIZ',
  DELIVER_ONLY_V2: 'DELIVER_ONLY_V2_BIZ',
  DELIVER_TRANSPORT_V2: 'DELIVER_TRANSPORT_V2_BIZ',
}
